import { useMemo } from 'react';
import type { MermaidStyle } from '@deckspace/types';
import { MermaidRenderer, type MermaidRendererData } from './index.js';
import { getVizIcon } from '../../utils/vizIcons.js';

interface MermaidAdapterProps {
  nodeId: string;
  code: string;
  mermaidStyle?: MermaidStyle;
}

const EMPTY_CONFIG = {} as const;

const MermaidIcon = getVizIcon('Mermaid');

export function MermaidView({ nodeId, code, mermaidStyle }: MermaidAdapterProps) {
  const data = useMemo<MermaidRendererData>(() => ({ code, mermaidStyle }), [code, mermaidStyle]);

  return (
    <div className="relative rounded-lg border border-border bg-card shadow-sm overflow-hidden h-[min(70vh,640px)] flex flex-col">
      {/* Header strip — provisional. May revert if it adds visual noise to flowing pages. */}
      <div className="flex items-center gap-1.5 px-2.5 py-1.5 border-b border-border text-xs text-muted-foreground shrink-0">
        <MermaidIcon size={12} />
        <span>Mermaid</span>
      </div>

      <div className="relative flex-1 min-h-0">
        <MermaidRenderer
          data={data}
          config={EMPTY_CONFIG}
          visualizationId={nodeId}
          interactionMode="click-to-interact"
        />
      </div>
    </div>
  );
}
